export const StorageItemTypes = {
  DIRECTORY: "DIRECTORY",
  FILE: "FILE",
  FORM: "FORM",
  TODO: "TODO",
  LINK: "LINK"
};
